import { DropDownButton, DropDownButtonItem, DropDownButtonItemClickEvent } from '@progress/kendo-react-buttons';
import { SvgIcon } from '@progress/kendo-react-common';
import { Skeleton } from '@progress/kendo-react-indicators';
import { Align } from '@progress/kendo-react-popup';
import { Card, CardHeader, CardBody } from '@progress/kendo-react-layout';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { PartialSpinny } from '../Nav/Spinny';
import { ITicketProps } from '../../types/Ticket/ITicket';
import * as svg from '@progress/kendo-svg-icons';
import { UserApi } from '../../redux/api/UserApi';
import { GameplanApi } from '../../redux/api/GameplanApi';


const Allocation: React.FC<ITicketProps> = (ticket) => {
    const navigate = useNavigate();
    const { data: profile } = UserApi.useGetUserProfileQuery();
    const { data: allocation } = GameplanApi.useGetTicketAllocationQuery({ ticketId: ticket.ID }, { skip: !ticket.ID || !ticket.Is_Workstream });
    const [view, setView] = React.useState('Time');
    const menuItemClicked = (e: DropDownButtonItemClickEvent) => {
        console.log('menu item clicked', e);
        if (e.item.text === 'Edit') {
            navigate('allocation');
        } else {
            setView(e.item.text);
        }
    }


    if (profile?.Features.External_Interface || (!ticket.Is_Workstream && !ticket.editMode)) return null;

    return (
        <Card className="ownership allocation">
            <CardHeader>
                <i><SvgIcon size='large' icon={svg.userOutlineIcon} className='mr-2' ></SvgIcon></i>
                <Link className='nav-link ownership-link' to='allocation' title='Edit Allocation'>Allocation<SvgIcon icon={svg.hyperlinkOpenIcon} className='d-none' /> </Link>
                <i className=''>
                    <DropDownButton fillMode='flat' onItemClick={menuItemClicked} svgIcon={svg.moreVerticalIcon} popupSettings={{ animate: false, popupClass: 'ownership-menu', popupAlign: { horizontal: 'right' } as Align }}>
                        <DropDownButtonItem svgIcon={svg.pencilIcon} text="Edit" />
                        <DropDownButtonItem svgIcon={svg.customFormatIcon} text="Time" render={(e) => <><SvgIcon icon={svg.customFormatIcon} />Time {view === 'Time' && <SvgIcon icon={svg.checkIcon} color='green' />}</>} />
                        <DropDownButtonItem svgIcon={svg.percentIcon} text="Percent" render={(e) => <><SvgIcon icon={svg.percentIcon} />Percent  {view === 'Percent' && <SvgIcon icon={svg.checkIcon} color='green' />}</>} />
                    </DropDownButton>

                </i>
            </CardHeader>
            <CardBody>
                {ticket.Is_Loading ? <Skeleton shape="rectangle" style={{ width: '100%', height: '50px', marginTop: '2px' }} /> :
                    <>{false ? <PartialSpinny /> :
                        <div className='info'>
                            <div className='header'>
                                <div className='col'>Staff</div>
                                <div className='col-2 r'>Est.</div>
                                <div className='col-2 r'>{profile.Features.Non_Bill_Time ? 'Bill' : 'Time'}</div>
                                {profile.Features.Non_Bill_Time && <div className='col-3 r'>Other</div>}
                            </div>
                            {allocation?.map(a => {
                                return (
                                    <div className='item'>
                                        <div className='col'>{a.Full_Name}</div>
                                        <div className='col-2 r'>{view === 'Time' ? a.Assigned_Mins_Bind : a.Assigned_Percent + '%'}</div>
                                        <div className='col-2 r'>{view === 'Time' ? a.Logged_Time_Bind : a.Percent_Complete}</div>
                                        {profile.Features.Non_Bill_Time && <div className='col-3 r'>{view === 'Time' ? a.Logged_NonBill_Time_Bind : a.NonBill_Percent}</div>}
                                    </div>
                                );
                            })}
                        </div>
                    }</>
                }
            </CardBody>
        </Card>
    );
};

export default Allocation;